import { render, staticRenderFns } from "./FinancialModule.vue?vue&type=template&id=0fa71014&scoped=true&"
import script from "./FinancialModule.vue?vue&type=script&lang=js&"
export * from "./FinancialModule.vue?vue&type=script&lang=js&"
import style0 from "./FinancialModule.vue?vue&type=style&index=0&id=0fa71014&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fa71014",
  null
  
)

export default component.exports